// src/hooks/useAuth.js
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const saved = localStorage.getItem("ielts_user");
    if (saved) setUser(JSON.parse(saved));
  }, []);

  const login = ({ user, token }) => {
    setUser(user);
    localStorage.setItem("ielts_user", JSON.stringify(user));
    localStorage.setItem("token", token);
    localStorage.setItem("identity_id", user.id);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("ielts_user");
    localStorage.removeItem("token");
    localStorage.removeItem("identity_id");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
